import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	done: {
		defaultMessage: 'Done',
		id: 'dashboard-edit.header-editable.done',
		description:
			'Label for the button that navigates user back to view mode after user has done editing.',
	},
});
